import DashboardLayout from "@/pages/layouts/DashboardLayout";

let sessionDaysRoutes = {
  path: '/session-days',
  component: DashboardLayout,
  redirect: '/session-days/list',
  children: [
    {
      path: 'list',
      name: 'Session Day List',
      component: () => import(/* webpackChunkName: "sessionDays" */  '@/pages/sessions/sessionDays/SessionDayList'),
      meta: {
        permissionsCodes: ['session-days/index'],
      }
    },
    {
      path: 'create',
      name: 'Add Session Day',
      component: () => import(/* webpackChunkName: "sessionDays" */  '@/pages/sessions/sessionDays/SessionDayForm'),
      meta: {
        permissionsCodes: ['session-days/create'],
      }
    },
    {
      path: 'edit/:id',
      name: 'Edit Session Day',
      component: () => import(/* webpackChunkName: "sessionDays" */  '@/pages/sessions/sessionDays/SessionDayForm'),
      meta: {
        permissionsCodes: ['session-days/update'],
      }
    }
  ]
}

export default sessionDaysRoutes;
